/**
 * Created by luka on 31.03.2018.
 */
import React from 'react';
import Snackbar from 'material-ui/Snackbar';


class InfoSnack extends React.Component {
    constructor() {
        super();

        this.state = {
            snackOpen: false,
            snackMessage: ''
        };

    }

    componentDidMount() {
        this.props.onRef(this)
    }
    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    showSnack = (text) => {
        this.setState({snackOpen: true, snackMessage: text});
    };

    closeSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({snackOpen: false});
    };

    render() {
        return (
            <div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.snackOpen}
                    onClose={this.closeSnack}
                    autoHideDuration={10000}
                    SnackbarContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{this.state.snackMessage}</span>}
                />

            </div>
        );
    }
}

export default InfoSnack;


// WEBPACK FOOTER //
// ./src/utils/InfoSnack.js